SupportBasePresentation = require('./base')
SupportLiveVoucherStatusAndNotesPresentation = require('./live_voucher_messages')

class SupportLiveVoucherPresenterPresentation extends SupportBasePresentation
	getLookupObject: () ->
		SupportLiveVoucherStatusAndNotesPresentation

module.exports = SupportLiveVoucherPresenterPresentation
